define('webshopAttributesEditView',[
  'module',
  'marionette',
  'underscore',
  'template!webshopAttributesEditView'
], function (
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  // Form shown in a ModalView for an attribute (options.kind = 'key': code, names, filter /
  // attribute flags) or a value ('value': code, names, colour or parameter). Writes into this.model.
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-attributes-edit-view',

    ui: {
      code: 'input.code',
      showInFilters: 'input.show-in-filters',
      showInAttributes: 'input.show-in-attributes',
      paramType: 'input.param-type',
      color: 'input.color',
      param: 'input.param'
    },

    events: {
      'input input.name': 'onNameChange',
      'input @ui.code': 'onCodeChange',
      'change @ui.showInFilters': 'onFlagsChange',
      'change @ui.showInAttributes': 'onFlagsChange',
      'change @ui.paramType': 'onParamChange',
      'input @ui.color': 'onParamChange',
      'input @ui.param': 'onParamChange'
    },

    initialize: function () {
      this.model.set('names', _.extend({}, this.model.get('names')));
    },

    serializeData: function () {
      var names = this.model.get('names') || {};
      var languages = _.union(this.options.languages || [], _.keys(names));
      var extra = this.model.get('extraParam1') || '';
      var isColor = extra.charAt(0) === '#';

      return {
        kind: this.options.kind,
        renameWarning: !!this.model.get('id'),
        languages: _.map(languages, function (lang) {
          return {lang: lang, name: names[lang] || ''};
        }),
        code: this.model.get('code') || '',
        showInFilters: !!this.model.get('showInFilters'),
        showInAttributes: !!this.model.get('showInAttributes'),
        paramType: isColor ? 'color' : (extra ? 'param' : 'none'),
        color: isColor ? extra : '#000000',
        param: isColor ? '' : extra
      };
    },

    onNameChange: function (e) {
      var names = _.extend({}, this.model.get('names'));
      names[$(e.currentTarget).data('lang')] = $(e.currentTarget).val();
      this.model.set('names', names);
      // A new item gets its code from the English name until the code is typed.
      if (!this.model.get('id') && !this.codeTyped && $(e.currentTarget).data('lang') === 'en') {
        this.ui.code.val($(e.currentTarget).val());
        this.model.set('code', $(e.currentTarget).val());
      }
    },

    onCodeChange: function () {
      this.codeTyped = true;
      this.model.set('code', this.ui.code.val());
    },

    onFlagsChange: function () {
      this.model.set('showInFilters', this.ui.showInFilters.is(':checked'));
      this.model.set('showInAttributes', this.ui.showInAttributes.is(':checked'));
    },

    onParamChange: function () {
      var type = this.$('input.param-type:checked').val();
      this.ui.color.prop('disabled', type !== 'color');
      this.ui.param.prop('disabled', type !== 'param');
      if (type === 'color')
        this.model.set('extraParam1', this.ui.color.val());
      else if (type === 'param')
        this.model.set('extraParam1', this.ui.param.val());
      else
        this.model.set('extraParam1', '');
    }
  });
});

